import { Form, Success, TotalWithdraw } from './components';

const WithdrawPortfolioFlow = {
  Form,
  Success,
  TotalWithdraw,
};

export { WithdrawPortfolioFlow };
